import { render, staticRenderFns } from "./ReportingInsights.vue?vue&type=template&id=40dbdb09&scoped=true"
import script from "./ReportingInsights.vue?vue&type=script&lang=js"
export * from "./ReportingInsights.vue?vue&type=script&lang=js"
import style0 from "./ReportingInsights.vue?vue&type=style&index=0&id=40dbdb09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dbdb09",
  null
  
)

export default component.exports